import type { RecentWin } from '../data/mockLots';
import { SkinFrame } from './SkinFrame';

export function RecentWinCard({
  win,
  index,
  onSelect,
}: { win: RecentWin; index: number; onSelect?: () => void }) {
  const savedPct = Math.round((1 - win.finalPrice / win.marketPrice) * 100);

  return (
    <article
      onClick={onSelect}
      className={`anim-rise relative grid grid-cols-[60px_1fr_auto] items-center gap-3 p-2.5 border border-edge/70 bg-bg-elev/30 ${onSelect ? 'cursor-pointer hover:border-edge-bright transition-colors' : ''}`}
      style={{ animationDelay: `${260 + index * 50}ms` }}
    >
      <div
        className="absolute left-0 top-0 bottom-0 w-[2px] bg-success/80"
      />

      <div className="relative overflow-hidden" style={{ aspectRatio: '1 / 0.8' }}>
        <SkinFrame
          weapon={win.weapon}
          palette={{ from: win.palette.from, to: win.palette.to, accent: win.palette.to }}
          size="sm"
          showPattern={false}
        />
      </div>

      <div className="min-w-0">
        <p className="font-display text-[12px] leading-tight truncate">
          <span className="text-success">@{win.username}</span>{' '}
          <span className="text-fg-muted">won</span>{' '}
          <span className="text-fg">{win.weaponLabel}</span>{' '}
          <span style={{ color: win.palette.to }}>| {win.skinName}</span>
        </p>
        <p className="font-mono text-[10px] text-fg-dim mt-0.5">{win.bidsCount} bids · {win.closedMinutesAgo}m ago</p>
      </div>

      <div className="text-right">
        <div className="font-mono font-bold text-success text-[14px] tabular-nums leading-none">
          ${win.finalPrice.toFixed(2)}
        </div>
        <div className="font-mono text-[10px] text-fg-dim mt-0.5">−{savedPct}%</div>
      </div>
    </article>
  );
}
